// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"65889d19","455":"55e40a73","977":"2fa3e54f"}[chunkId] + ".chunk.js";
};